import React, { useState } from 'react'
import { Button, Container, DialogContent, DialogTitle } from '@material-ui/core'
import { Dialog } from 'components/shared/Dialog'
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline'

function OnboardingErrorDialog({ open, applicantName, errorMessage, onRetry, onClose }) {
    const [retryLoading, setRetryLoading] = useState(false)

    const handleRetry = async () => {
        setRetryLoading(true)
        try {
            await onRetry()
        } finally {
            setRetryLoading(false)
        }
    }

    return (
        <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
            <DialogTitle>FactorCloud Onboarding Error</DialogTitle>
            <DialogContent>
                <div className="text-center">
                    <ErrorOutlineIcon style={{ fontSize: 48, color: 'var(--badge-declined-ink)' }} />
                    {applicantName && (
                        <div className="mt-3 mb-2">
                            <strong>{applicantName}</strong>
                        </div>
                    )}
                    <div className="mt-2 mb-4" style={{ color: 'var(--badge-declined-ink)' }}>
                        {errorMessage}
                    </div>
                </div>
                <Container className="redirect-fc-buttons">
                    <Button variant="outlined" onClick={onClose}>
                        Close
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleRetry}
                        disabled={retryLoading}
                    >
                        {retryLoading ? "Retrying..." : "Retry Onboarding"}
                    </Button>
                </Container>
            </DialogContent>
        </Dialog>
    )
}

export default OnboardingErrorDialog